<template>
  <div>
    <div v-closable="{ exclude: ['contextTitleWrapper'], isClosable: true, handler: 'closeEditable'}" :ref="'contextTitleWrapper'">
      <template>
        <div class="context--title" :class="{'editable': isEditable, 'expandable': isExpandable, 'editing': isTitleEditable}"  @click="isExpanded = !isExpanded, openEditable($event)">
          <slot name="custom--icon" />
          <span v-show="!isTitleEditable" class="context--title__text" :class="{'title--20': title__20}">
            {{ title }}
            <i v-if="enableInfoIcon" class="fas fa-info-circle"></i>
          </span>
          <input v-show="isTitleEditable" @input="handleTitleEditableInput" class="editable--title" type="text" :value="contentTitle" :ref="editableTitleID"/>
          <span class="context--title__badge" v-if="badgeNumber >= 0">{{ badgeNumber }}</span>
          <div v-if="icon !== null" class="context--title__icon">
            <i :class="icon"></i>
          </div>
          <div v-if="isExpandable" class="context--title__expandable">
            <i :class="[expandFlag || isExpanded ? 'fas fa-angle-up' : 'fas fa-angle-down']"></i>
          </div>
        </div>
      </template>
    </div>
    <div v-if="isExpanded">
      <slot name="expandablePart"></slot>
    </div>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'
export default {
  name: 'ContextTitle',
  props: {
    title: { type: String, default: '' },
    title__20: { type: Boolean, default: false },
    icon: { type: String, default: null },
    enableInfoIcon: { type: Boolean, default: true },
    badgeNumber: { type: Number, default: -1 },
    isExpandable: { type: Boolean, default: false },
    expandFlag: { type: Boolean, default: false },
    isEditable: { type: Boolean, deafult: false }
  },
  data () {
    return {
      isTitleEditable: false,
      contentTitle: this.title,
      editableTitleID: null,

      isExpanded: false
    }
  },
  mounted () {
    this.editableTitleID = uuid.v4()
  },
  methods: {
    openEditable (evt) {
      this.$nextTick(() => {
        if (this.isEditable) {
          setTimeout(() => {
            this.$refs[this.editableTitleID].focus()
          }, 20)
        }
      })
      if (this.isEditable) {
        this.isTitleEditable = !this.isTitleEditable
      }
      this.$emit('open-editable', evt)
    },
    closeEditable () {
      this.isTitleEditable = false
    },
    handleTitleEditableInput (evt) {
      this.contentTitle = evt.target.value
      this.$emit('input-title', this.contentTitle)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
